import domready from 'domready';
import branch from './branch';
import optimizely from './optimizely';
import globalPromo from './globalPromoBanner';
import cartDropdown from './cartDropdown';
import search from './search';

cartDropdown.init();

domready(() => {
  search.init();
  branch.init();
  globalPromo.init();
  optimizely.init();
});
